export interface CompetitionRow {
  act: string;
  signature: string;
  publication: string;
}

export interface Competition {
  slug: string;
  label: string;
  caption: string;
  rows: CompetitionRow[];
}

export const competitions: Competition[] = [
  {
    slug: "first",
    label: "1° Concurso",
    caption: "Edital de dezembro de 1990 · Convocações até julho de 1992",
    rows: [
      { act: "Edital", signature: "13 de dezembro de 1990", publication: "Entre 18 e 19 de dezembro de 1990" },
      { act: "Resultado Final", signature: "19 de abril de 1991", publication: "19 de dezembro de 1991" },
      { act: "Ato de Homologação", signature: "07 de maio de 1991", publication: "08 de maio de 1991" },
      { act: "Convocação 17º e 18º", signature: "19 de agosto de 1991", publication: "03 de setembro de 1991" },
      { act: "Convocação 19º ao 33º", signature: "15 de outubro de 1991", publication: "21 de outubro de 1991" },
      { act: "Convocação 40º ao 47º", signature: "27 de abril de 1992", publication: "30 de abril de 1992" },
      { act: "Convocação 49º", signature: "09 de junho de 1992", publication: "26 de junho de 1992" },
      { act: "Convocação 50º ao 64º", signature: "03 de junho de 1992", publication: "01 de julho de 1992" },
    ],
  },
  {
    slug: "second",
    label: "2° Concurso",
    caption: "Edital de maio de 1993 · Prorrogação até outubro de 1995",
    rows: [
      { act: "Edital", signature: "24 de maio de 1993", publication: "Entre 28 de maio e 04 de junho de 1993" },
      { act: "Resultado Final", signature: "—", publication: "28 de setembro de 1993" },
      { act: "Ato de Homologação", signature: "04 de outubro de 1993", publication: "11 de outubro de 1993" },
      { act: "Convocação 1º ao 14º", signature: "05 de outubro de 1993", publication: "13 de outubro de 1993" },
      { act: "Convocação 15º ao 18º", signature: "09 de novembro de 1993", publication: "16 de novembro de 1993" },
      { act: "Prorrogação do Concurso", signature: "14 de setembro de 1995", publication: "04 de outubro de 1995" },
    ],
  },
  {
    slug: "third",
    label: "3° Concurso",
    caption: "Edital de julho de 2002 · Convocações até janeiro de 2004",
    rows: [
      { act: "Edital", signature: "12 de julho de 2002", publication: "16 de julho de 2002" },
      { act: "Resultado Final", signature: "07 de fevereiro de 2003", publication: "17 de fevereiro de 2003" },
      { act: "Termo de Homologação", signature: "27 de fevereiro de 2003", publication: "11 de março de 2003" },
      { act: "Convocação 1º ao 8º", signature: "10 de março de 2003", publication: "20 de março de 2003" },
      { act: "Convocação 9º ao 10º", signature: "23 de junho de 2003", publication: "25 de junho de 2003" },
      { act: "Convocação 11º", signature: "10 de dezembro de 2003", publication: "16 de dezembro de 2003" },
      { act: "Convocação 12º", signature: "22 de dezembro de 2003", publication: "02 de janeiro de 2004" },
    ],
  },
  {
    slug: "fourth",
    label: "4° Concurso",
    caption: "Edital de dezembro de 2016 · Convocações até julho de 2022",
    rows: [
      { act: "Edital", signature: "15 de dezembro de 2016", publication: "15 de dezembro de 2016" },
      { act: "Resultado Final", signature: "08 de maio de 2017", publication: "08 de maio de 2017" },
      { act: "Homologação do Concurso", signature: "28 de dezembro de 2017", publication: "09 de janeiro de 2018" },
      { act: "Prorrogação da Validade", signature: "10 de dezembro de 2019", publication: "13 de dezembro de 2019" },
      { act: "Suspensão da validade (Covid-19)", signature: "14 de maio de 2021", publication: "17 de maio de 2021" },
      { act: "Restabelecimento da validade", signature: "17 de dezembro de 2021", publication: "17 de dezembro de 2021" },
      { act: "Convocação", signature: "12 de abril de 2018", publication: "12 de abril de 2018" },
      { act: "Convocação", signature: "20 de julho de 2018", publication: "24 de julho de 2018" },
      { act: "Convocação", signature: "11 de novembro de 2020", publication: "07 de dezembro de 2020" },
      { act: "Convocação", signature: "10 de junho de 2021", publication: "11 de junho de 2021" },
      { act: "Convocação", signature: "23 de junho de 2021", publication: "25 de junho de 2021" },
      { act: "Convocação", signature: "30 de junho de 2022", publication: "05 de julho de 2022" },
    ],
  },
];
